<template>
  <div class="team-page">
    <div class="modal" v-if="isShow" @click="hideModal()" @touchmove.prevent>
      <div class="content">
        <div class="swipe">
          <mt-swipe :auto="0" @change="handleChange" :defaultIndex="certIndex">
            <mt-swipe-item v-for="item in certs" :key="item">
              <img :src="item">
            </mt-swipe-item>
          </mt-swipe>
        </div>
      </div>
      <div class="cover"></div>
    </div>

    <div class="scroll-wrapper">
      <div class="scroll-content">
        <div class="swipe">
          <mt-swipe :auto="4000" :show-indicators="false">
            <mt-swipe-item v-for="item in bannerList" :key="item">
              <img :src="item">
            </mt-swipe-item>
          </mt-swipe>
        </div>

        <div class="introduction">
          <div class="text service">
            <p>服务团队</p>
            <span>
              工程师服务团队拥有完善的数据分析软硬件支持和SOP标准服
              务流程体系，非外包全日制服务团队，高标准的服务质量要求，
              售后无忧有保障
            </span>
          </div>
          <div class="imgWrapper left">
            <div class="img">
              <img src="https://tu.auntec.cn/app/gsx/about/team_pic2%403x.jpg">
            </div>
            <div class="block"></div>
          </div>
        </div>

        <div class="introduction">
          <div class="text research">
            <p>研发团队</p>
            <span>
              公司研发团队有海外10多年的技术经验积累，开发的数据恢复
              产品技术居于国内领先地位，团队有严格的信息安全管控保障
              十分注重用户的数据信息保护
            </span>
          </div>
          <div class="imgWrapper right">
            <div class="img">
              <img src="https://tu.auntec.cn/app/gsx/about/team_pic3%403x.jpg">
            </div>
            <div class="block"></div>
          </div>
        </div>

        <div class="introduction last">
          <div class="text about">
            <p>关于我们</p>
            <span>
              果师兄团队拥有50多名经验丰富的研发和数据恢复工程师，现
              已服务用户超百万级，用户遍布国内各省市、自治区、港澳台
              及欧美、东南亚等地区
            </span>
          </div>
          <div class="imgWrapper left">
            <div class="img">
              <img src="https://tu.auntec.cn/app/gsx/about/team_pic1%403x.jpg">
            </div>
            <div class="block"></div>
          </div>
        </div>

        <ul class="intelligence">
          <li class="promise">
            <div class="title">
              <span class="text">
                <img src="../assets/images/global_doublepay@3x.png">
                双倍赔付承诺
              </span>
              <span class="link" 
                @click="goArticle(primary_url,'双倍赔付承诺说明')">
                详细标准
              </span>
            </div>
            <div class="content">
              凡通过我们没能恢复成功，通过其他渠道成功恢复
              的，凭相关凭证，我们双倍退款，并免费赠送数据恢
              复软件一套。
            </div>
          </li>
          <li class="cert-section">
            <div class="title">
              <img class="icon" src="../assets/images/team_brand@3x.png">
              品牌保障
            </div>
            <ul class="certs">
              <li v-for="(item,index) in certs" :key="item">
                <img :src="item" @click="showModal(index)">
              </li>
            </ul>
          </li>
          <li class="corpinfo">
            <div class="title">
              <span class="text">联系我们</span>
              <span class="link" 
                @click="goArticle(cert_url,'营业执照')">
                营业执照
              </span>
            </div>
            <ul class="detail">
              <li>
                <img src="../assets/images/global_add@3x.png">
                <span>地址：江苏省苏州市星湖街328号创意产业园6-604单元</span>
              </li>
              <li>
                <img src="../assets/images/global_mail@3x.png">
                邮箱：<span>gsx@auntec.com</span>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
    <Footer_></Footer_>
  </div>

</template>

<script>
import Footer_ from './Footer.vue';
import ServiceSteps from './modules/ServiceSteps';
import CopyrightFooter from './modules/CopyrightFooter'

export default {
  metaInfo: {
        title: '果师兄官网_苹果手机数据恢复|微信聊天记录恢复|电脑数据恢复', // set a title
        meta: [{                 // set meta
          name: 'keyWords',
          content: '果师兄恢复大师,苹果数据恢复软件,手机数据恢复软件,电脑数据恢复'
        },{                 // set meta
          name: 'description',
          content: '果师兄恢复大师为用户提供电脑手机数据恢复服务,主要服务包括微信聊 天记录,短信,备忘录,微信好友添加,照片等苹果手机数据恢复,回收站清空文件恢复,U 盘/硬 盘/SD 卡/储存卡等各类存储设备数据恢复,以及相关的数据迁移、数据删除等指导服务'
        }]
  },
  data(){
    return{
      code:"",
      goodsList:[],//商品列表
      H5_URL:window.config.H5_URL,
      redirect:true,
      m_guoshixiong_aboutus: {
        'channel': "m.gsx.aboutus",
        'channel_name': "关于我们页面-立即下载",
      },
      dl_href:window.config.gsx_dl_base+'m.gsx.aboutus',
      bannerList: [],
      certs: [],
      isShow: false,
      app_id: window.config.appid,
      primary_url: window.config.API_URL1+'/apph5/page/guarantee?app_id='+window.config.appid,
      cert_url: window.config.API_URL1+'/apph5/page/trading?app_id='+window.config.appid,
      certIndex: 0
    }
  },
  mounted(){
        
  },
  created(){
    this.getBanner()
  },
  methods:{
      handleChange(index){
        this.sa_m_qualification(
          window.location.href,
          this.certs[index]
        )
      },
      goArticle(url,title){
        if(title == '双倍赔付承诺说明'){
          this.sa_m_click_promise_detail(window.location.href)
        }
        if(title == '营业执照'){
          this.sa_m_business_licence(window.location.href)
        }
        this.$router.push({name:"article",query:{url:url,title:title}})
      },
      showModal(index){
        this.sa_m_qualification(
          window.location.href,
          this.certs[0]
        )
        this.certIndex = index
        this.isShow = true;
      },
      hideModal(){
        this.isShow = false
      },
      getBanner(){
        let info = {
          app_id: '30001081'
        }
        this.$store.dispatch('getSystemConfig',info).then((res)=>{
          let result = res.data
          if(result.code==0){
            this.bannerList = result.res.about_banner.iphone8p
            if(this.bannerList.length==0){
              this.bannerList.push('../assets/images/default_banner_x@3x.png')
            }
            this.certs = result.res.brand_certificate
          }
        })
      }
  },
  components:{
    Footer_,
    ServiceSteps,
    CopyrightFooter
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Team.vue